import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import NotFound from './pages/NotFound'
import Login from './pages/Login'
import useTheme from './store/useTheme'
import useAuth from './store/useAuth'

function App() {
  const init = useTheme((s) => s.init)
  const isAuthenticated = useAuth((s) => s.isAuthenticated)

  useEffect(() => {
    init()
  }, [init])

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 transition-colors duration-300">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={isAuthenticated() ? <Dashboard /> : <Navigate to="/login" replace />}
        />
        <Route
          path="*"
          element={isAuthenticated() ? <NotFound /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </div>
  )
}

export default App
